import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';



// export const apiURL_BACKEND = "http://127.0.0.1:8000/api"; //"https://picksandprofits.com/api";
// export const apiMediaURL_BACKEND = "http://127.0.0.1:8000/api_media"; //"https://picksandprofits.com/api_media";
// export const webUrl = "http://127.0.0.1:3000"; //"https://picksandprofits.com"
export const botUsername = "MichisPicksCorutine_bot";

export const apiURL_BACKEND = "https://picksandprofits.com/api";
export const apiMediaURL_BACKEND = "https://picksandprofits.com/api_media";
export const webUrl = "https://picksandprofits.com"


export interface AgentPackage {
    pk: number,
    name: string,
    title: string,
    description: string,
    price: number,
    validity: number, // In months
}

export interface UserDataInterface {
    username: string;
    email: string;
    referrer: string | null;
    refer_code: string | null;
    date_joined: string;
    package: AgentPackage | null;
    balance: number;
    user_type: string | null;
    tme_username: string | null;
}
export interface TestimonialInterface {
    imgUrl: string;
    username: string;
    message: string;
}
export interface ProductDataInterface {
    name: string,
    type: string,
    price: number,
}

export interface PaymentCartInterface {
    payID: string,
    qrImageURL: string,
    payCurrency: string,
    payAddress: string,
    payAmount: number,
    expireAt: string,
    fiatAmount: string
}

export interface PackagePassInterface {
    model: string;
    pk: number;
    fields: {
        title: string,
        price: number,
        description: string,
        package_type: string,
        game_type: string,
        date_created: string,
        game_date: string,
        updated_at: string,
        active: string
    };
}


export interface PackageInterface {
    model: string;
    pk: number;
    fields: {
        id: number,
        title: string,
        price: number,
        description: string,
        package_type: string,
        game_type: string,
        date_created: string,
        game_date: string,
        updated_at: string,
        active: string,
        top_selling: boolean,
    };
}

export interface Transaction {
        type:string,
        amount:number,
        status:string,
        date_created:string
}
export interface userPackageInterface {
    model: string;
    pk: number;
    fields: {
        date_created: string,

        date_expired: string,

        package: number,

        user: number,
    }
}
export const formatTitleText = (text: string) =>
    text
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');


//This function checks if user type is determined or not
export const useJustifyUserType = () => {
    const [userData, setUserData] = useState<UserDataInterface>();
    const navigate = useNavigate();
    useEffect(() => {
        const res = axios.get(`${apiURL_BACKEND}/getUser/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            var data = res.data;
            console.log(data);

            setUserData({
                username: data.username,
                email: data.email,
                referrer: data.referrer,
                refer_code: data.refer_code,
                date_joined: data.date_joined,
                package: data.package,
                balance: data.balance,
                user_type: data.user_type,
                tme_username: data.tme_username
            })
            console.log("Package type ---> ", data.package);
        });

    }, [])

    useEffect(() => {
        if (userData) {
            console.log("User type ---> ", userData.user_type);
            if (!userData.user_type) {
                navigate("/select-user-type/");
            }
        }
    }, [
        userData
    ])
    return userData
}


export interface NotificationInterface { id: number; text: string, type: string }
